import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import countries from "assets/files/countries.json"

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  CardTitle,
  CardSubtitle,
  Alert,
} from "reactstrap"

import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation"

import Dropzone from "react-dropzone"

import classnames from "classnames"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// Nomination Accreditation service
import NominationAccreditation from "services/NominationAccreditation.service"

// Image Viewer
import ViewFiles from "components/Services/environment/en/ViewFiles"

import DecisionInfo from "components/Services/environment/en/DecisionInfo"
import General from "services/GeneralEndpoints"
import DocumentUpload from "components/Services/Common/DocumentUpload"
import ApplicantDetails from "components/ApplicantDetails/ApplicantDetails"
import InstitutionDetails from "pages/Common/InstitutionDetails"
import NominationAccreditationPreview from "components/Preview/NominationAccreditationPreview"
import AccreditationAttachments from "./Attachments"

const STATIC_FILES = process.env.REACT_APP_STATIC_FILES
const BASE_URL = process.env.REACT_APP_BASE_URL

const user = JSON.parse(localStorage.getItem("authUser"))
const nominationAccreditionService = new NominationAccreditation(user)

let generalService = new General(user)

const NominationLetterApply = props => {
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabProgress, setactiveTabProgress] = useState(1)
  const [progressValue, setprogressValue] = useState(25)
  const [activeTabVartical, setoggleTabVertical] = useState(1)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [productTypes, setproductTypes] = useState([])
  const [isReturned, setisReturned] = useState(false)

  const [selectedFiles, setselectedFiles] = useState([])
  const [uploadedImages, setUploadedImages] = useState([])
  const [alreadySubmitted, setalreadySubmitted] = useState(false)
  const [uploadedFiles, setuploadedFiles] = useState([])

  const deliveryPartnerFormRef = useRef(null)

  // form attributes
  const [applicationId, setapplicationId] = useState()
  const [loading, setloading] = useState(false)
  const [submitted, setsubmitted] = useState(false)
  const [error, seterror] = useState()
  const [applicationDetails, setApplicationDetails] = useState({})

  // submitted Application Details
  const [submittedApplication, setsubmittedApplication] = useState()
  const [subimttedFormData, setsubmittedFormData] = useState({})
  const [disableFormFields, setdisableFormFields] = useState(false)
  const [currentPath, setcurrentPath] = useState(
    window.location.pathname + props.location.search
  )
  const [showDecisionInfo, setshowDecisionInfo] = useState(false)
  const [decisionInfo, setDecisionInfo] = useState({})
  const [companies, setcompanies] = useState()
  const [companyId, setcompanyId] = useState()
  const [measures, setmeasures] = useState()
  const [measureId, setmeasureId] = useState("")
  const [legalStatusType, setlegalStatusType] = useState()

  const [productTypesRaw, setproductTypesRaw] = useState([])
  const [serviceAttachments, setserviceAttachments] = useState([])
  const [measuresRaw, setmeasuresRaw] = useState()
  const [editMode, seteditMode] = useState(false)

  const attachmentsFormRef = useRef(null)

  const [isFreshApplication, setisFreshApplication] = useState(true)
  const [showDocuments, setshowDocuments] = useState(false)
  const [renderOtherItems, setrenderOtherItems] = useState(false)
  const [nominationType, setNominationType] = useState("")
  const [cancelUpload, setcancelUpload] = useState(false)
  

  useEffect(() => {
    //console.log(subimttedFormData)
    setcancelUpload(true)
  }, [subimttedFormData])

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    setuser(userObj)
    fetchCompanies()
    fetchServiceAttachments()

    if (
      currentPath.includes("view-application") ||
      currentPath.includes("edit-application")
    ) {
      //show decision info card
      setshowDecisionInfo(true)
      setapplicationId(props.location.search.split("=")[1])

      nominationAccreditionService
        .getApplicationDetails(props.location.search.split("=")[1])
        .then(response => {
          console.log("submitted app details --> ", response)
          if (response.status) {
            setsubmittedFormData({
              ...response.data,
            })

            // Form fields etc
            if (response.data.application_status_id === 7) {
              setisFreshApplication(false)
              setdisableFormFields(false)
              setisReturned(true)
              setshowDocuments(true)
              seteditMode(true)
              setrenderOtherItems(true)
            } else {
              setisFreshApplication(false)
              setdisableFormFields(true)
              setshowDocuments(true)
            }

            // set some variables
            setlegalStatusType(
              response.data.accreditation_request.legal_status
            )

            // Comments
            let comments = ""
            let certUrl = "#"
            if (response.data.application_status_id === 7) {
              // get comments from officer
              response.data.application_flow_histories.forEach(hist => {
                if (hist.application_status_id === 7) {
                  comments = hist.comment_to_applicant
                }
              })
            }

            if (response.data.application_status_id === 6) {
              // get certificate download url
              if (
                response.data.manually_processed != undefined &&
                response.data.manually_processed == true
              ) {
                certUrl = STATIC_FILES + response.data.manually_processed.path
              } else {
                certUrl =
                  BASE_URL + "verify/certificate/" + response.data.app_id
              }
            }

            // set decision info
            setDecisionInfo({
              statusId: response.data.application_status_id,
              status: response.data.application_status.name,
              service: response.data.service.name,
              comments: comments,
              certUrl: certUrl,
              isManuallyProcessed: response.data.manually_processed,
              manual_certificate: response.data.manual_certificate,
              final_certificate_uploaded:
                response.data.final_certificate_uploaded,
            })

            // Set application details
            setsubmittedFormData({
              ...response.data.accreditation_request,
            })

            // Set company Id
            if (
              response.data.accreditation_request.legal_status ==
              "private"
            ) {
              setcompanyId(
                response.data.accreditation_request.company.id
              )
            }

            // set uploaded documents
            setUploadedImages(response.data.application_attachments)
          }
        })
    } else {
      nominationAccreditionService.createApplication(userObj).then(response => {
        // console.log("response from create app --> ", response)
        setapplicationId(response.data.id)
        seteditMode(true)
      })
    }
  }, [])

  const fetchCompanies = () => {
    generalService.getCompanies().then(response => {
      // console.log(response)
      if (response.status) {
        const comps = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setcompanies(comps)
      }
    })
  }

  const handleNominationTypeChange = event => {
    setNominationType(event.target.value)
  }

  const submitApplication = () => {
    // alert("submitting application")
    var uploaded_files = []

    setloading(true)
    uploadedFiles.forEach(attach => {
      uploaded_files.push({
        application_id: applicationId,
        description: attach.description,
        file: attach.file,
      })
    })

    nominationAccreditionService
      .saveApplication({
        ...applicationDetails,
        project_name: applicationDetails.project_name? applicationDetails.project_name : "N/A",
        application_id: applicationId,
      })
      .then(response => {
        if (response) {
          // if (isReturned && !showDocuments) {
          //   plasticsApp.bulkFileUpload(uploaded_files)
          // } else if (isFreshApplication) {
          //   plasticsApp.bulkFileUpload(uploaded_files)
          // }
          nominationAccreditionService.bulkFileUpload(uploaded_files)
          setsubmitted(true)
        } else {
          seterror("Error encountered while submitting application")
          setloading(false)
        }
      })
  }

  const validateApplicationDetails = formData => {
    console.log("form-data")
    console.log(formData)

    setApplicationDetails({ ...formData })
    setactiveTab(2)
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        setactiveTab(tab)
      }
    }
  }

  const fetchServiceAttachments = () => {
    // get service attachments
    // for testing purposes, we will use hard-coded values for the documents
    // const tempDocs = [
    //   {
    //     name: "Official Application Letter",
    //     description: "Official Application Letter",
    //     is_mandatory: true,
    //     info: "",
    //   },
    //   {
    //     name: "Legal Status Document",
    //     description: "Legal Status Document",
    //     is_mandatory: true,
    //     info: "",
    //   },
    //   {
    //     name: "Track Record",
    //     description: "Track Record",
    //     is_mandatory: true,
    //     info: "share information about environmental related projects implemented by your organization",
    //   },
    //   {
    //     name: "Concept Note / Full Proposal",
    //     description: "Concept Note / Full Proposal",
    //     is_mandatory: false,
    //     info: "",
    //   },
    // ]
    const attachments = AccreditationAttachments.map((attachment, index) => (
      <Row key={index}>
        <span>{attachment.description}</span>
        {attachment.info && attachment.info != "" ? <i style={{color: "blue"}}>{attachment.info}</i> : null}
        <input
          className="form-control"
          type="file"
          //onChange={onChangeProductImage}
          id={attachment.name}
          required={attachment.is_mandatory}
          accept=".pdf,image/*"
        />
        <hr></hr>
      </Row>
    ))
    setserviceAttachments(attachments)
  }

  const prepareUploadFiles = e => {
    let current_attachments = []
    let kount = 0
    for (kount = 0; kount < serviceAttachments.length; kount++) {
      if (e.target[kount].files.length > 0) {
        current_attachments.push({
          application_id: applicationId,
          description: e.target[kount].id,
          file: e.target[kount].files[0],
        })
      }
    }
    console.log("upload files", current_attachments)
    setuploadedFiles(current_attachments)
    setactiveTab(3)
  }

  const initiateReupload = () => {
    setshowDocuments(false)
    setcancelUpload(false)
  }

  const showUploadedFiles = () => {
    setcancelUpload(false)
    setshowDocuments(true)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Apply | Accreditation Letter</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            maintitle="Dashboard"
            title="Application"
            breadcrumbItem="Request for accreditation to the GCF"
          />

          {showDecisionInfo ? (
            <Row>
              <Col sm="12">
                <DecisionInfo data={decisionInfo} />
              </Col>
            </Row>
          ) : (
            ""
          )}

          {!submitted ? (
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4">
                      Request for accreditation to the GCF
                    </h4>
                    <div className="form-horizontal form-wizard-wrapper wizard clearfix">
                      <div className="steps clearfix">
                        <ul>
                          <NavItem
                            className={classnames({ current: activeTab === 1 })}
                          >
                            <NavLink
                              className={classnames({
                                current: activeTab === 1,
                              })}
                              onClick={() => {
                                //setactiveTab(1)
                              }}
                            >
                              <span className="number">1.</span> Application
                              Details
                            </NavLink>
                          </NavItem>
                          <NavItem
                            className={classnames({ current: activeTab === 2 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 2,
                              })}
                              onClick={() => {
                                //setactiveTab(2)
                              }}
                            >
                              <span className="number">2.</span> Document
                              Uploads
                            </NavLink>
                          </NavItem>

                          <NavItem
                            className={classnames({ current: activeTab === 3 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 3,
                              })}
                              onClick={() => {
                                //setactiveTab(3)
                              }}
                            >
                              <span className="number">3.</span>
                              Confirm Detail
                            </NavLink>
                          </NavItem>
                        </ul>
                      </div>
                      <div className="content clearfix">
                        <TabContent activeTab={activeTab} className="body">
                          <TabPane tabId={1}>
                            <AvForm
                              onValidSubmit={(e, v) => {
                                validateApplicationDetails(v)
                              }}
                              model={subimttedFormData}
                            >
                              {error ? (
                                <Alert color="danger">{error}</Alert>
                              ) : null}
                              <Row>
                                <Col md={4}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="select"
                                        name="legal_status"
                                        label="Select Legal Status"
                                        value={legalStatusType}
                                        required
                                        disabled={disableFormFields}
                                        onChange={e => {
                                          setlegalStatusType(e.target.value)
                                        }}
                                      >
                                        <option value="">--select--</option>
                                        <option value="private">
                                          Private Company
                                        </option>
                                        {/* <option value="individual">
                                          Individual
                                        </option> */}
                                        <option value="ngo">NGO</option>
                                        <option value="government">
                                          Government Institution
                                        </option>
                                      </AvField>
                                    </div>
                                  </Row>
                                </Col>

                                {legalStatusType === "individual" ? (
                                  <>
                                    <Col md={4}>
                                      <Row className="mb-3">
                                        <div>
                                          <AvField
                                            type="text"
                                            name="tin"
                                            label="Identification Number"
                                            value={
                                              subimttedFormData.tin
                                                ? subimttedFormData.tin
                                                : ""
                                            }
                                            required
                                            disabled={disableFormFields}
                                          />
                                        </div>
                                      </Row>
                                    </Col>
                                    <Row>
                                      <ApplicantDetails />
                                    </Row>
                                  </>
                                ) : (
                                  <Col md="4">
                                    {legalStatusType === "private" ? (
                                      <>
                                        <Row>
                                          <AvField
                                            type="select"
                                            name="company_id"
                                            label="Select Company"
                                            required
                                            value={companyId}
                                            disabled={disableFormFields}
                                          >
                                            <option>--Select Company</option>
                                            {companies}
                                          </AvField>
                                        </Row>
                                      </>
                                    ) : null}
                                  </Col>
                                )}
                              </Row>
                              {(legalStatusType === "ngo" ||
                                legalStatusType === "government") && (
                                <InstitutionDetails
                                  disableFormFields={disableFormFields}
                                  data={subimttedFormData}
                                />
                              )}
                              <hr></hr>
                              <Row>
                                <Col md={4}>
                                  <AvField
                                    type="select"
                                    name="nomination_approach"
                                    label="Select Nomination Approach/Category"
                                    required
                                    value={
                                      subimttedFormData.nomination_approach
                                        ? subimttedFormData.nomination_approach
                                        : ""
                                    }
                                    onChange={handleNominationTypeChange}
                                  >
                                    <option>
                                      ----Select Nomination Type----
                                    </option>
                                    <option
                                      value={"Institutional accreditation"}
                                    >
                                      Institutional accreditation
                                    </option>
                                    <option value={"Project Specific approach"}>
                                      Project Specific approach
                                    </option>
                                  </AvField>
                                </Col>
                                {nominationType ===
                                  "Project Specific approach" && (
                                  <Col md={4}>
                                    <AvField
                                      name="project_name"
                                      label="Project Name"
                                      required
                                    />
                                  </Col>
                                )}
                                {nominationType ===
                                  "Institutional accreditation" && (
                                  <Col md={4}>
                                    <AvField
                                      type="select"
                                      name="access_entity_type"
                                      label="Select Access Entity Type"
                                      required
                                      value={
                                        subimttedFormData.access_entity_type
                                          ? subimttedFormData.access_entity_type
                                          : ""
                                      }
                                    >
                                      <option value={""}>
                                        ------Select-------
                                      </option>
                                      <option value={"Direct Access Entities"}>
                                        Direct Access Entities
                                      </option>
                                      <option
                                        value={"International Access Entities"}
                                      >
                                        International Access Entities
                                      </option>
                                    </AvField>
                                  </Col>
                                )}
                              </Row>
                              <br></br>
                              {/* <Row>
                                <AvField 
                                    type="text"
                                    name="project_name"
                                    label="Project Name"
                                    required
                                    value={subimttedFormData.project_name ? subimttedFormData.project_name : ""}

                                />
                              </Row> */}
                              <Col md={6}>
                                <AvField
                                  type="select"
                                  name="nationality"
                                  label="Select Applicant Nationality"
                                  required
                                  disabled={disableFormFields}
                                  value={
                                    subimttedFormData.nationality ? subimttedFormData.nationality : ""
                                  }
                                >
                                  <option>----Select Nationality----</option>
                                  {countries.map((country, key) => (
                                    <option key={key} value={country.name}>
                                      {country.name}
                                    </option>
                                  ))}
                                </AvField>
                              </Col>{" "}
                              
                              <br></br>
                              <Row>
                                <Col md={8}>
                                  <AvField
                                    type="textarea"
                                    name="project_description"
                                    label="Project Description"
                                    required
                                    disabled={disableFormFields}
                                    rows={6}
                                    c
                                    value={
                                      subimttedFormData.project_description
                                        ? subimttedFormData.project_description
                                        : ""
                                    }
                                  />
                                </Col>
                              </Row>
                              <br></br>
                              <Row>
                                <Col md={8}>
                                  <AvField
                                    type="textarea"
                                    name="alignment_to_mandate"
                                    label="Alignment of applicant to the mandate & objectives of the GCF"
                                    required
                                    disabled={disableFormFields}
                                    rows={6}
                                    value={
                                      subimttedFormData.alignment_to_mandate
                                        ? subimttedFormData.alignment_to_mandate
                                        : ""
                                    }
                                  />
                                </Col>
                              </Row>
                              <br></br>
                              {/* <Row>
                                <>
                                  <Col md={8}>
                                    <AvField
                                      type="textarea"
                                      name="request_details"
                                      label="Request Details"
                                      required
                                      disabled={disableFormFields}
                                      rows={6}
                                      value={
                                        subimttedFormData.request_details
                                          ? subimttedFormData.request_details
                                          : ""
                                      }
                                    />
                                  </Col>
                                </>
                              </Row> */}
                              <br></br>
                              <Row style={{ display: "none" }}>
                                <Col md={12}>
                                  <button
                                    ref={deliveryPartnerFormRef}
                                    onClick={() => {
                                      // props.onHide()
                                      // setmodal(false)
                                    }}
                                    type="submit"
                                    style={{ float: "right", fontSize: 18 }}
                                    className="btn btn-primary col-3"
                                    disabled={loading}
                                  >
                                    Next
                                  </button>
                                </Col>
                              </Row>
                            </AvForm>
                          </TabPane>
                          <TabPane tabId={2}>
                            <Row>
                              <Col className="col-12">
                                <Card>
                                  <CardBody>
                                    <CardTitle className="h4">
                                      Document Upload
                                    </CardTitle>

                                    {showDocuments ? (
                                      <ViewFiles
                                        attachments={uploadedImages}
                                        isReturned={isReturned}
                                        reupload={initiateReupload}
                                      />
                                    ) : (
                                      // <ViewFiles data={uploadedImgages} />
                                      <div className="mb-5">
                                        <form
                                          onSubmit={e => {
                                            e.preventDefault()
                                            prepareUploadFiles(e)
                                          }}
                                        >
                                          <Row>
                                            <Col md={12}>
                                              {serviceAttachments}
                                            </Col>

                                            <DocumentUpload />
                                          </Row>
                                          {isReturned ? (
                                            <center>
                                              <a
                                                href="#"
                                                onClick={showUploadedFiles}
                                                className="btn btn-warning"
                                              >
                                                Cancel Upload
                                              </a>
                                            </center>
                                          ) : null}
                                          <Row style={{ display: "none" }}>
                                            <Col md={12}>
                                              <button
                                                ref={attachmentsFormRef}
                                                type="submit"
                                              >
                                                Upload Attachments
                                              </button>
                                            </Col>
                                          </Row>
                                        </form>
                                      </div>
                                    )}
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={3}>
                            <div className="row justify-content-center">
                              <Col lg="6">
                                <div className="text-center">
                                  <div className="mb-4">
                                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                                  </div>
                                  <div>
                                    <h5>Proceed to submit Application</h5>
                                  </div>
                                </div>
                              </Col>
                            </div>
                            {editMode ? (
                              <NominationAccreditationPreview
                                data={applicationDetails}
                              />
                            ) : null}
                          </TabPane>
                        </TabContent>
                      </div>
                      <div className="actions clearfix">
                        <ul>
                          <li
                            className={
                              activeTab === 1 ? "previous disabled" : "previous"
                            }
                          >
                            <Link
                              to={currentPath}
                              className="btn btn-primary"
                              onClick={() => {
                                toggleTab(activeTab - 1)
                              }}
                            >
                              Previous
                            </Link>
                          </li>
                          <li
                            className={
                              activeTab === 3 ? "next disabled" : "next"
                            }
                          >
                            <Link
                              to={currentPath}
                              className="btn btn-primary"
                              onClick={() => {
                                if (activeTab === 1) {
                                  deliveryPartnerFormRef.current.click()
                                } else if (activeTab === 2) {
                                  if (!disableFormFields) {
                                    if (!cancelUpload) {
                                      attachmentsFormRef.current.click()
                                    } else if (isFreshApplication) {
                                      attachmentsFormRef.current.click()
                                    } else if (!showDocuments) {
                                      attachmentsFormRef.current.click()
                                    } else {
                                      toggleTab(3)
                                    }
                                  }
                                } else {
                                  toggleTab(activeTab + 1)
                                }
                              }}
                            >
                              Next
                            </Link>
                          </li>
                          {activeTab === 3 ? (
                            <li style={{ float: "right" }}>
                              <Link
                                to="#"
                                className="btn btn-primary"
                                onClick={() => {
                                  submitApplication()
                                }}
                                disabled={disableFormFields}
                              >
                                Submit
                              </Link>
                            </li>
                          ) : (
                            ""
                          )}
                        </ul>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <Row>
              <Card>
                <CardBody>
                  <div className="row justify-content-center">
                    <Col lg="6">
                      <div className="text-center">
                        <div className="mb-4">
                          <i className="mdi mdi-check-circle-outline text-success display-4" />
                        </div>
                        <div>
                          <h5>Application succesfully submitted</h5>
                        </div>
                        <>
                          <Link
                            to="/dashboard"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleTab(activeTab + 1)
                            }}
                          >
                            Back
                          </Link>
                        </>
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default NominationLetterApply
